import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import { FormGroup, FormGroupDirective, ReactiveFormsModule } from '@angular/forms';
import { ENUM_HelpCaseType } from '@api-new/common';
import { ClientUserData } from '@platform/smart-search/models/client-user-data.model';
import { AddSmartSearchDialogFormRemortgageSpeakToAnExpert } from '@platform/smart-search/utils/formUtils';
import { FormFieldWrapperComponent } from '@shared-lib/components/form-components/form-field-wrapper/form-field-wrapper.component';
import { InputTextAreaComponent } from '@shared-lib/components/form-components/input-text-area/input-text-area.component';
import { InputTextComponent } from '@shared-lib/components/form-components/input-text/input-text.component';
import { SelectComponent } from '@shared-lib/components/form-components/select/select.component';
import { ValueType } from '@shared-lib/enums/value-type.enum';
import { StepperComponent } from '@shared/components/stepper/stepper.component';
import { helpCaseTypeSelectItems } from '@shared/contants';

const EXCLUDED_HELP_CASE_TYPES_FOR_REMORTGAGE: ENUM_HelpCaseType[] = [
  ENUM_HelpCaseType.HELP_CASE_TYPE_FIRST_TIME_BUYER,
  ENUM_HelpCaseType.HELP_CASE_TYPE_BUY_TO_LET,
  ENUM_HelpCaseType.HELP_CASE_TYPE_MOVE_HOME,
];

@Component({
  selector: 'cp-add-smart-search-remortgage-speak-to-an-expert',
  imports: [StepperComponent, FormFieldWrapperComponent, InputTextComponent, ReactiveFormsModule, InputTextAreaComponent, SelectComponent],
  templateUrl: './add-smart-search-remortgage-speak-to-an-expert.component.html',
  styleUrls: ['../add-smart-search-dialog-step.component.scss', './add-smart-search-remortgage-speak-to-an-expert.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddSmartSearchRemortgageSpeakToAnExpertComponent implements OnInit {
  @Input({ required: true }) formGroupName: string;
  @Input({ required: true }) clientUserData: ClientUserData;
  @Input({ required: true }) isSaving: boolean;
  @Input() isBackButtonVisible = true;
  @Output() nextClicked = new EventEmitter();
  @Output() backClicked = new EventEmitter();

  private readonly rootFormGroup = inject(FormGroupDirective);

  protected stepFormGroup: FormGroup<AddSmartSearchDialogFormRemortgageSpeakToAnExpert>;
  protected readonly ValueType = ValueType;
  protected readonly helpCaseTypeSelectItems = helpCaseTypeSelectItems.filter(
    (type) => !EXCLUDED_HELP_CASE_TYPES_FOR_REMORTGAGE.includes(type.value),
  );

  ngOnInit(): void {
    this.stepFormGroup = this.rootFormGroup.control.get(this.formGroupName) as FormGroup<AddSmartSearchDialogFormRemortgageSpeakToAnExpert>;
    this.stepFormGroup.patchValue({
      phoneNumber: this.clientUserData.phoneNumber,
    });
  }

  emitNextClicked(): void {
    if (this.stepFormGroup.valid) {
      this.nextClicked.emit();
    }
  }

  emitBackClicked(): void {
    this.backClicked.emit();
  }
}
